import { render, staticRenderFns } from "./ClientsSubscribers.vue?vue&type=template&id=6f628093&"
import script from "./ClientsSubscribers.vue?vue&type=script&lang=js&"
export * from "./ClientsSubscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports